export default {
      id: "common__server-no-connection-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#common__server-no-connection",
      toString: function () {
        return this.url;
      }
    }